const getters = {
	caretype: (): String => "permanent" as String
};

export default { namespaced: true, getters };
